import { Avatar, Chip, makeStyles } from "@material-ui/core";
import { CustomerStatus as SMOCustomerStatus } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  {
    customerStatus: {
      "& .MuiChip-avatar": {
        borderRadius: "500rem",
        height: 15,
        width: 15
      },
      "& .MuiChip-label": {
        fontSize: 12,
        fontWeight: "bold",
        paddingLeft: 8
      },
      cursor: "pointer",
      paddingLeft: 10
    },
    existingCustomerStatus: {
      "& .MuiChip-avatar": {
        backgroundColor: "#5D7FFE !important"
      },
      backgroundColor: "#BAC8FF"
    },
    newCustomerStatus: {
      "& .MuiChip-avatar": {
        backgroundColor: "#FFCE22 !important"
      },
      backgroundColor: "#FFF0BD"
    }
  },
  { name: "CustomerStatus" }
);

interface CustomerStatusProps {
  status: SMOCustomerStatus;
}

const CustomerTypeStatus: React.FC<CustomerStatusProps> = props => {
  const classes = useStyles(props);
  const { status } = props;

  const customerStatus = status === SMOCustomerStatus.ACT ? "EXISTING" : "NEW";

  return (
    <Chip
      className={classNames(classes.customerStatus, {
        [classes.newCustomerStatus]: status === SMOCustomerStatus.NEW,
        [classes.existingCustomerStatus]: status === SMOCustomerStatus.ACT
      })}
      avatar={<Avatar />}
      label={customerStatus}
    />
  );
};

CustomerTypeStatus.displayName = "CustomerTypeStatus";
export default CustomerTypeStatus;
